import {
  GET_TCG_MATCHES,
  GET_VGC_MATCHES,
  ADD_TCG_MATCH,
  ADD_VGC_MATCH,
  UPDATE_TCG_MATCH,
  UPDATE_VGC_MATCH,
  DELETE_TCG_MATCH,
  DELETE_VGC_MATCH,
  CLEAR_MATCHES,
  MATCH_ERROR,
  SET_LOADING
} from '../types';

const UnifiedMatchReducer = (state, action) => {
  switch (action.type) {
    case GET_TCG_MATCHES:
      return {
        ...state,
        tcgMatches: action.payload,
        loading: false
      };
    case GET_VGC_MATCHES:
      return {
        ...state,
        vgcMatches: action.payload,
        loading: false
      };
    case ADD_TCG_MATCH:
      return {
        ...state,
        tcgMatches: [action.payload, ...state.tcgMatches],
        loading: false
      };
    case ADD_VGC_MATCH:
      return {
        ...state,
        vgcMatches: [action.payload, ...state.vgcMatches],
        loading: false
      };
    case UPDATE_TCG_MATCH:
      return {
        ...state,
        tcgMatches: state.tcgMatches.map(match => 
          match._id === action.payload._id ? action.payload : match
        ),
        loading: false
      };
    case UPDATE_VGC_MATCH:
      return {
        ...state,
        vgcMatches: state.vgcMatches.map(match => 
          match._id === action.payload._id ? action.payload : match
        ),
        loading: false
      };
    case DELETE_TCG_MATCH:
      return {
        ...state,
        tcgMatches: state.tcgMatches.filter(match => match._id !== action.payload),
        loading: false
      };
    case DELETE_VGC_MATCH:
      return {
        ...state,
        vgcMatches: state.vgcMatches.filter(match => match._id !== action.payload),
        loading: false
      };
    case CLEAR_MATCHES:
      return {
        ...state,
        tcgMatches: [],
        vgcMatches: [],
        loading: false
      };
    case MATCH_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};

export default UnifiedMatchReducer;